import React from 'react'

const HeaderSearch = () => (
  <div aria-disabled="true" aria-label="Búsqueda no disponible" className="pl4-shell-search" role="search">
    <i className="fas fa-search" aria-hidden="true" />
    <span>Buscar...</span>
    <kbd>⌘K</kbd>
  </div>
)

export default HeaderSearch
